
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { assertIsFn, AddContext } from "@storybook/addon-docs";

import { Canvas, Meta, Story } from '@storybook/addon-docs';
import template from './badge.twig';
const badgeStory = (args) => {
  // Don't bother with the inline options if they don't exist or are defaults
  if (args.icon === '') {
    delete args.icon;
  }
  return template(args);
};


const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Meta title="Components/Badge" argTypes={{
      label: {
        type: {
          name: 'string'
        }
      },
      icon: {
        options: ['', 'check', 'heart', 'pencil'],
        type: {
          name: 'string'
        },
        control: {
          type: 'select'
        }
      }
    }} mdxType="Meta" />
    <h1>{`Badge`}</h1>
    <p>{`Badges help provide just a smidge more context to repetitive or serialized content. For example, a badge can help the reader identify when `}<a parentName="p" {...{
        "href": "/docs/components-comment--role-author#role-badges"
      }}>{`a comment on an article is by the author of that article`}</a>{`.`}</p>
    <Canvas mdxType="Canvas">
  <Story name="Basic" args={{
        label: 'Hello'
      }} mdxType="Story">
    {args => badgeStory(args)}
  </Story>
    </Canvas>
    <h2>{`With icon`}</h2>
    <Canvas mdxType="Canvas">
  <Story name="With icon" args={{
        icon: 'check',
        label: 'Verified'
      }} mdxType="Story">
    {args => badgeStory(args)}
  </Story>
    </Canvas>
    <h2>{`Template Properties`}</h2>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`class`}</inlineCode>{` (string)`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`icon`}</inlineCode>{` (string, optional): The name of one of `}<a parentName="li" {...{
          "href": "/docs/design-icons--page"
        }}>{`our icons`}</a>{` to display.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`message`}</inlineCode>{` (string, default `}<inlineCode parentName="li">{`'Label'`}</inlineCode>{`)`}</li>
    </ul>
    <h2>{`Template Blocks`}</h2>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`content`}</inlineCode>{`: The main label content, typically the value of `}<inlineCode parentName="li">{`message`}</inlineCode>{`.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`extra`}</inlineCode>{`: A visual extra preceding the content, typically populated by an icon if `}<inlineCode parentName="li">{`icon`}</inlineCode>{` is set.`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;

export const basic = (args => badgeStory(args));
basic.storyName = 'Basic';
basic.args = {
  label: 'Hello'
};
basic.parameters = { storySource: { source: 'args => badgeStory(args)' } };

export const withIcon = (args => badgeStory(args));
withIcon.storyName = 'With icon';
withIcon.args = {
  icon: 'check',
  label: 'Verified'
};
withIcon.parameters = { storySource: { source: 'args => badgeStory(args)' } };

const componentMeta = { title: 'Components/Badge', argTypes: {
  label: {
    type: {
      name: 'string'
    }
  },
  icon: {
    options: ['', 'check', 'heart', 'pencil'],
    type: {
      name: 'string'
    },
    control: {
      type: 'select'
    }
  }
}, includeStories: ["basic","withIcon"],  };

const mdxStoryNameToKey = {"Basic":"basic","With icon":"withIcon"};

componentMeta.parameters = componentMeta.parameters || {};
componentMeta.parameters.docs = {
  ...(componentMeta.parameters.docs || {}),
  page: () => <AddContext mdxStoryNameToKey={mdxStoryNameToKey} mdxComponentAnnotations={componentMeta}><MDXContent /></AddContext>,
};

export default componentMeta;